import { LayoutItemSize, Spacing } from './LayoutTypes'

export const spaceMap: Map<Spacing | undefined, number> = new Map([
    ['none', 0],
    ['small', 3],
    ['standard', 5],
])

export const spaceMapToPixel: Map<Spacing | undefined, string> = new Map([
    ['none', '0px'],
    ['small', '8px'],
    ['standard', '16px'],
    ['medium', '24px'],
    ['big', '32px'],
])

export const mapSpaceValue = (
    space?: Spacing | Spacing[]
): string | undefined | (string | undefined)[] => {
    if (Array.isArray(space)) {
        return space.map(value => spaceMapToPixel.get(value))
    }
    return spaceMapToPixel.get(space)
}

type WidthProps = {
    flexGrow?: number
    width?: string
    noExpand?: boolean
}

export const getWidthProps = (columnWidth: LayoutItemSize): WidthProps => {
    if (typeof columnWidth === 'string') {
        return {
            width: columnWidth,
            noExpand: true,
        }
    }

    return {
        flexGrow: columnWidth,
    }
}

type HeightProps = {
    flexGrow?: number
    height?: string
    noExpand?: boolean
}

export const getHeightProps = (rowHeight: LayoutItemSize): HeightProps => {
    if (typeof rowHeight === 'string') {
        return {
            height: rowHeight,
            noExpand: true,
        }
    }

    return {
        flexGrow: rowHeight || 0,
        noExpand: !rowHeight,
    }
}
